import { create } from "zustand";
import { createMessage } from "../repositories/MessageRepository";
import { Message } from "../Models/Message";

export interface MessageStore {
  addMessage: (message: Message) => Promise<number>;
}

export const useMessage = create<MessageStore>(() => ({
  addMessage: (message) => {
    return createMessage(message);
  },
}));
